import { render, staticRenderFns } from "./vLandingHolder.vue?vue&type=template&id=c29130ec&scoped=true"
import script from "./vLandingHolder.vue?vue&type=script&lang=js"
export * from "./vLandingHolder.vue?vue&type=script&lang=js"
import style0 from "./vLandingHolder.vue?vue&type=style&index=0&id=c29130ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29130ec",
  null
  
)

export default component.exports